let originalFetch: typeof globalThis.fetch | null = null;
let fetchPatched = false;

const PRODUCTION_WEBSITE_HOSTS = new Set(["constructorfleet.com", "www.constructorfleet.com"]);

function inferApiBaseUrlFromLocation() {
  const hostname = globalThis.location?.hostname?.trim().toLowerCase() ?? "";
  if (!PRODUCTION_WEBSITE_HOSTS.has(hostname)) {
    return "";
  }

  const protocol = globalThis.location?.protocol === "http:" ? "http:" : "https:";
  return `${protocol}//api.constructorfleet.com`;
}

export function getApiBaseUrl() {
  return import.meta.env.VITE_API_BASE_URL?.trim() || inferApiBaseUrlFromLocation();
}

export function resolveApiUrl(path: string) {
  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl || !path.startsWith("/api/")) {
    return path;
  }

  return new URL(path, apiBaseUrl).toString();
}

export function installApiFetchPatch() {
  if (typeof window === "undefined" || fetchPatched) {
    return;
  }

  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) {
    return;
  }

  originalFetch = window.fetch.bind(window);
  window.fetch = ((input: RequestInfo | URL, init?: RequestInit) => {
    if (typeof input === "string") {
      return originalFetch!(resolveApiUrl(input), init);
    }

    if (input instanceof URL) {
      return originalFetch!(resolveApiUrl(input.toString()), init);
    }

    return originalFetch!(input, init);
  }) as typeof window.fetch;

  fetchPatched = true;
}

export function resetApiFetchPatch() {
  if (typeof window !== "undefined" && originalFetch) {
    window.fetch = originalFetch;
  }

  originalFetch = null;
  fetchPatched = false;
}
